export const getTopLevelCommentId = (comment = {}, commentsById = new Map()) => {
  const parentId = comment.parentCommentId;
  if (!parentId) return comment.id || "";

  const parent = commentsById.get(parentId);
  if (!parent || parent.parentCommentId) {
    return parent?.parentCommentId || parentId;
  }

  return parentId;
};

export const buildCommentThreads = (comments = []) => {
  const commentsById = new Map(comments.map((comment) => [comment.id, comment]));
  const topLevelComments = [];
  const repliesByParentId = new Map();

  comments.forEach((comment) => {
    const parentId = getTopLevelCommentId(comment, commentsById);

    if (!comment.parentCommentId || parentId === comment.id) {
      topLevelComments.push(comment);
      return;
    }

    const parentReplies = repliesByParentId.get(parentId) || [];
    parentReplies.push({ ...comment, parentCommentId: parentId });
    repliesByParentId.set(parentId, parentReplies);
  });

  return { topLevelComments, repliesByParentId };
};

export const getCommentCountLabel = (count = 0) => {
  const safeCount = Number(count) || 0;
  return `${safeCount} ${safeCount === 1 ? "Comment" : "Comments"}`;
};
